import Text from '../components/Text';
import { memo, useCallback, useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import { AgentType, MessageItem, MessageTypeEnum } from '../type';
import { isMobile, updateMessageContainerScroll } from '../../utils/utils';
import styles from './style.module.less';
import AgentTip from '../components/AgentTip';
import classNames from 'classnames';
import { MsgDataType } from '../../common/type';
import ChatItem from '../../components/ChatItem';
type Props = {
    curSkill?: any;
    id: string;
    chatId: any;
    session_id?: any;
    messageList: MessageItem[];
    historyVisible: boolean;
    currentAgent?: AgentType;
    chatVisible?: boolean;
    isDeveloper?: boolean;
    integrateSystem?: string;
    isSimpleMode?: boolean;
    isDebugMode?: boolean;
    onMsgDataLoaded: (data: MsgDataType, questionId: string | number, question: string, valid: boolean, isRefresh?: boolean) => void;
    onSendMsg: (value: string) => void;
    currentAgenticon?: any;
    agent6Id?: any;
    skillId?: any;
    currentSessionMapIdRef?: any;
    linkToSession?: any;
    sessionListRef?: any;
    formatSessionList?: any;
    resCode?: any;
    goLogin?: any;
    isNewSessionRef?: any;
    userid?: any;
    onParseStateChange?: (isParsing: boolean) => void;
    checkIsLogin?: any;
};

const MessageContainer: React.FC<Props> = ({
    curSkill,
    id,
    chatId,
    messageList,
    historyVisible,
    currentAgent,
    chatVisible,
    isDeveloper,
    integrateSystem,
    isSimpleMode,
    isDebugMode,
    onMsgDataLoaded,
    onSendMsg,
    currentAgenticon,
    agent6Id,
    skillId,
    currentSessionMapIdRef,
    linkToSession,
    sessionListRef,
    formatSessionList,
    resCode,
    goLogin,
    isNewSessionRef,
    userid,
    onParseStateChange,
    checkIsLogin
}) => {
    const [triggerResize, setTriggerResize] = useState(false);
    const [containerVisible, setContainerVisible] = useState(false);
    const onResize = useCallback(() => {
        setTriggerResize(true);
        setTimeout(() => {
            setTriggerResize(false);
        }, 0);
    }, []);
    useEffect(() => {
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    useEffect(() => {
        setContainerVisible(true);

        // 确保在组件挂载后滚动到底部
        const scrollTimeout = setTimeout(() => {
            const container = document.getElementById('messageContainer');
            if (container) {
                // 使用 scrollTo 方法确保滚动到最底部
                container.scrollTo({
                    top: container.scrollHeight + 200,
                    behavior: 'smooth'
                });
            }
        }, 500);

        return () => clearTimeout(scrollTimeout);
    }, []);
    useEffect(() => {
        if (messageList.length > 0) {
            // 增加延迟确保新消息已经渲染完成
            const timer = setTimeout(() => {
                const container = document.getElementById('messageContainer');
                if (container) {
                    container.scrollTop = container.scrollHeight + 100;
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [messageList]);
    useEffect(() => {
        onResize();
    }, [historyVisible, chatVisible]);

    const messageContainerClass = classNames(styles.messageContainer, { [styles.mobile]: isMobile });
    return (
        <div id={id} className={messageContainerClass}>
            <div className={styles.messageList}>
                {currentAgent && (
                    <AgentTip currentAgent={currentAgent} onSendMsg={onSendMsg} curSkill={curSkill} currentAgenticon={currentAgenticon} />
                )}
                {messageList.map((msgItem: MessageItem, index: number) => {
                    const {
                        id: msgId,
                        questionId,
                        modelId,
                        agentId,
                        type,
                        msg,
                        msgValue,
                        score,
                        identityMsg,
                        parseInfos,
                        parseTimeCost,
                        msgData,
                        filters
                    } = msgItem;
                    return (
                        <div key={msgId} id={`${msgId}`} className={styles.messageItem}>
                            {type === MessageTypeEnum.TEXT && <Text position="left" data={msg} />}
                            {/* {type === MessageTypeEnum.AGENT_LIST && (
                <AgentTip currentAgent={currentAgent} onSendMsg={onSendMsg} currentAgenticon={currentAgenticon} />
              )} */}
                            {type === MessageTypeEnum.QUESTION && (
                                <>
                                    {/* 提问会话样式组件 */}
                                    <Text position="right" data={msg} />
                                    {identityMsg && <Text position="left" data={identityMsg} />}
                                    {/* 回答会话样式组件 */}
                                    <ChatItem
                                        questionId={questionId}
                                        currentAgent={currentAgent}
                                        isSimpleMode={isSimpleMode}
                                        isDebugMode={isDebugMode}
                                        msg={msgValue || msg || ''}
                                        parseInfos={parseInfos}
                                        parseTimeCostValue={parseTimeCost}
                                        msgData={msgData}
                                        conversationId={chatId}
                                        modelId={modelId}
                                        agentId={agentId}
                                        score={score}
                                        filter={filters}
                                        triggerResize={triggerResize}
                                        isDeveloper={isDeveloper}
                                        integrateSystem={integrateSystem}
                                        onMsgDataLoaded={(data: MsgDataType, valid: boolean, isRefresh) => {
                                            onMsgDataLoaded(data, msgId, msgValue || msg || '', valid, isRefresh);
                                        }}
                                        onUpdateMessageScroll={updateMessageContainerScroll}
                                        onSendMsg={onSendMsg}
                                        isLastMessage={index === messageList.length - 1}
                                        currentAgenticon={currentAgenticon}
                                        agent6Id={agent6Id}
                                        skillId={skillId}
                                        currentSessionMapIdRef={currentSessionMapIdRef}
                                        linkToSession={linkToSession}
                                        sessionListRef={sessionListRef}
                                        formatSessionList={formatSessionList}
                                        resCode={resCode}
                                        goLogin={goLogin}
                                        isNewSessionRef={isNewSessionRef}
                                        userid={userid}
                                        onParseStateChange={onParseStateChange}
                                        checkIsLogin={checkIsLogin}
                                    />
                                </>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

function areEqual(prevProps: Props, nextProps: Props) {
    if (
        prevProps.id === nextProps.id &&
        isEqual(prevProps.messageList, nextProps.messageList) &&
        prevProps.historyVisible === nextProps.historyVisible &&
        prevProps.currentAgent === nextProps.currentAgent &&
        prevProps.chatVisible === nextProps.chatVisible &&
        prevProps.isSimpleMode === nextProps.isSimpleMode
    ) {
        return true;
    }
    return false;
}

export default memo(MessageContainer, areEqual);
